import { DrawingType } from './types';

export type FileIdentitySnapshot = {
  localId?: number;
  _id?: string;
  downloadSrc?: string;
  title?: string;
  type?: string;
  data?: {
    name?: string;
  };
};

function resolveFileIdentity(
  file: FileIdentitySnapshot
): string | undefined {
  if (typeof file.localId === 'number') {
    return `local:${file.localId}`;
  }

  if (file._id) {
    return `remote:${file._id}`;
  }

  if (file.downloadSrc) {
    return `download:${file.downloadSrc}`;
  }

  if (file.title || file.type) {
    return `fallback:${file.title || ''}:${file.type || ''}:${file.data?.name || ''}`;
  }

  return undefined;
}

export function alignDrawingsWithFiles(
  previousFiles: FileIdentitySnapshot[],
  nextFiles: FileIdentitySnapshot[],
  currentDrawings: DrawingType[]
): DrawingType[] {
  if (!nextFiles.length) {
    return [];
  }

  const drawingsByIdentity = new Map<string, DrawingType>();

  previousFiles.forEach((file, index) => {
    const drawing = currentDrawings[index];
    if (!drawing) {
      return;
    }

    const identity = resolveFileIdentity(file);
    if (!identity) {
      return;
    }

    drawingsByIdentity.set(identity, drawing);
  });

  return nextFiles.map((file) => {
    const identity = resolveFileIdentity(file);
    if (!identity) {
      return undefined;
    }

    return drawingsByIdentity.get(identity);
  });
}
